import { render, staticRenderFns } from "./OneReport.vue?vue&type=template&id=89f6c386&scoped=true&"
import script from "./OneReport.vue?vue&type=script&lang=js&"
export * from "./OneReport.vue?vue&type=script&lang=js&"
import style0 from "./OneReport.vue?vue&type=style&index=0&id=89f6c386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f6c386",
  null
  
)

export default component.exports